/**
 * @fileoverview POST handler for the "/analytics_dashboard/:app_group_id/email_engagement_by_providers_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { analyticsDashboardAppGroupIdEmailEngagementByProvidersDataCacheKeys } from "./constants";
import type {
  AnalyticsDashboardAppGroupIdEmailEngagementByProvidersDataProps,
  analyticsDashboardAppGroupIdEmailEngagementByProvidersDataResult,
} from "./types";

/* eslint-disable camelcase */
export const postAnalyticsDashboardAppGroupIdEmailEngagementByProvidersData = reactQueryMutationAdapter(
  analyticsDashboardAppGroupIdEmailEngagementByProvidersDataCacheKeys,
  ({
    app_group_id,
    ...props
  }: AnalyticsDashboardAppGroupIdEmailEngagementByProvidersDataProps): Promise<analyticsDashboardAppGroupIdEmailEngagementByProvidersDataResult> => {
    return fetch(`/analytics_dashboard/${app_group_id}/email_engagement_by_providers_data`, "GET", props);
  }
);
